import ZeroShotClassifier from './ZeroShotClassifier';
import classify from './classify';

export { ZeroShotClassifier, classify };
